
import {PropertyBase} from "./PropertyBase";
import * as React from "react";
import {SearchableSelect} from "shared/controls/SingleInputs/SearchableSelect/SearchableSelect";
import {Dialog} from "shared/controls/Dialogs/core/Dialog";
import {FontUploader} from "InternalShared/Dialog/FileUploader";
import {LicenseIsRequired} from "InternalShared/Dialog/LicenseIsRequired";


declare let rednaoPDFInvoiceParams:any;

export class FontFamilyProperty extends PropertyBase{
    public label:string='Color';


    public SubRenderer(): React.ReactNode {
        return (
            <SearchableSelect  Value={this.GetOptionValue()} onChange={e=>this.ChangeFont(e)} Label={'Font Family'}>
                <option value={''}>Default</option>
                {rednaoVar.AvailableFonts.map(x=>
                    <option key={x} value={x}>{x}</option>
                )}

                <option value={'dejavu sans'}>Deja vu (Pre installed)</option>
                <option value={'$add_new'}>Add Font</option>
            </SearchableSelect>
        );
    }


    private async ChangeFont(font: string) {
        if(font=='$add_new')
        {
            if(rednaoVar.IsPr=='')
            {
                Dialog.Show(<LicenseIsRequired Message={"Custom fonts are only available in the full version"}/>);
                return;
            }
            font=await Dialog.Show(<FontUploader/>);
            if(font==''||font==null) {
                return;
            }
        }

        this.SetOptionValue(font)
    }
}

